import type posthog from "posthog-js";

type PostHog = typeof posthog;

export const POSTHOG_API_KEY = "phc_wfeIjkCTYrvJq1z23xlu3CWgrSSjmmoDSIzbUQMd51S";
export const POSTHOG_API_HOST = "https://us.i.posthog.com";

export const getPostHogConfig = () => {
  const isLocalDevelopment = window.location.hostname === "localhost";

  return {
    api_host: POSTHOG_API_HOST,
    opt_out_capturing_by_default: isLocalDevelopment,
    disable_session_recording: true,
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    debug: false
  };
};

export interface IdentifyUserParams {
  userId: string;
  userProperties?: Record<string, unknown>;
  tenantId?: string;
  tenantName?: string;
}

export const identifyUser = (posthog: PostHog, params: IdentifyUserParams) => {
  const { userId, userProperties, tenantId, tenantName } = params;

  posthog.identify(userId, userProperties);
  posthog.startSessionRecording();

  if (tenantId) {
    posthog.group("tenant", tenantId, { name: tenantName });
  }
};

export const resetPostHogIdentity = (posthog: PostHog) => {
  posthog.reset();
  posthog.stopSessionRecording();
};

export const captureError = (
  posthog: PostHog,
  error: Error | unknown,
  context?: Record<string, unknown>
) => {
  const errorProperties = {
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : undefined,
    ...context
  };

  posthog.capture("error", errorProperties);
};
